import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import Cell from './Cell';
import Row from './Row';

const GridHeader = ({ channels, isSticky }) => {
    const classNames = ['grid-header'];
    if (isSticky) {
        classNames.push('sticky-header');
    }

    return (
        <Row className={classNames.join(' ')}>
            <Cell verticalHeader noBorder />
            {channels.map((channel, key) => {
                const { icon, name, guideUrl } = channel;
                return (
                    <Cell key={key} noBorder>
                        <Link to={guideUrl}>
                            <img src={icon} title={name} />
                        </Link>
                    </Cell>
                );
            })}
        </Row>
    );
};

GridHeader.propTypes = {
    channels: PropTypes.arrayOf(PropTypes.object).isRequired,
    isSticky: PropTypes.bool,
};

export default GridHeader;



// WEBPACK FOOTER //
// ./src/components/ChannelCapabilitiesGrid/Header.js